/** Civil date used by Tosho, independent of the browser/server timezone. */
export function parisCalendarDate(now: Date): string {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  return ['year', 'month', 'day']
    .map((type) => parts.find((part) => part.type === type)!.value)
    .join('-');
}

/** Position in the existing 360-unit SVG. Follow the actual bar, not the end
 * of the month cell; missing financial data must not move the civil date. */
export function monthlyChartDateBoundary(year: number, date: string): number {
  const [currentYear, month, day] = date.split('-').map(Number) as [number, number, number];
  if (year < currentYear) return 1;
  if (year > currentYear) return 0;
  const firstMonth = year === 2020 ? 9 : 1;
  if (month < firstMonth) return 0;
  const column = 340 / (year === 2020 ? 4 : 12);
  const barWidth = Math.min(22, column * 0.68);
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const center = 10 + column * (month - firstMonth + 0.5);
  return (center - barWidth / 2 + barWidth * (day / days)) / 360;
}
